import React from "react"
import PaymentsDashboard from "./PaymentsDashboard"

type Props = {}

const Reports: React.FC<Props> = ({}) => {
  return (
    <section>
      <PaymentsDashboard />
    </section>
  )
}

export default Reports
